import { initContract } from "@ts-rest/core";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    GetOrganizationAccessTokenResponseSchema,
    OrganizationAccessTokenPathParamsSchema,
    OrganizationWebhookPortalResponseSchema,
    RotateOrganizationAccessTokenResponseSchema,
} from "../schemas/domains/organizationAccessToken/organization-access-token.schema";

const c = initContract();

export const organizationAccessTokenContract = c.router(
    {
        get: {
            method: "GET",
            path: "",
            pathParams: OrganizationAccessTokenPathParamsSchema,
            responses: {
                200: GetOrganizationAccessTokenResponseSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        rotate: {
            method: "POST",
            path: "/rotate",
            pathParams: OrganizationAccessTokenPathParamsSchema,
            body: c.noBody(),
            responses: {
                201: RotateOrganizationAccessTokenResponseSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        webhookPortal: {
            method: "POST",
            path: "/webhook-portal",
            pathParams: OrganizationAccessTokenPathParamsSchema,
            body: c.noBody(),
            responses: {
                201: OrganizationWebhookPortalResponseSchema,
                401: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/organization/:organizationId/access-token",
    },
);
